export default __webpack_public_path__ + "static/media/notetaker.6e264845.png";